module.exports = __webpack_public_path__ + "img/icon-briefcase.58726f5f.svg";